export type CompatibilityPersonInput =
  | { mode: "sign"; sign: string }
  | {
      mode: "dob";
      birthMonth: string;
      birthDay: string;
      birthYear: string;
    };

export type CompatibilityCategory = "personal" | "marriage" | "business" | "team";
export type CompatibilityPageMode =
  | "personal"
  | "business"
  | "team"
  | "classroom";

export function buildComprehensiveCompatibilityPayload(
  person1: CompatibilityPersonInput,
  person2: CompatibilityPersonInput,
  compatibilityType: CompatibilityCategory | "comprehensive" = "comprehensive",
): Record<string, string | number> {
  const payload: Record<string, string | number> = {
    compatibilityType,
  };

  if (person1.mode === "sign") payload.sign1 = person1.sign;
  else {
    payload.birthMonth1 = Number(person1.birthMonth);
    payload.birthDay1 = Number(person1.birthDay);
    payload.birthYear1 = Number(person1.birthYear);
  }

  if (person2.mode === "sign") payload.sign2 = person2.sign;
  else {
    payload.birthMonth2 = Number(person2.birthMonth);
    payload.birthDay2 = Number(person2.birthDay);
    payload.birthYear2 = Number(person2.birthYear);
  }

  return payload;
}

export function filterCompatibilityReportsByType<
  T extends { compatibilityType: string },
>(reports: T[] | undefined, compatibilityType: CompatibilityCategory): T[] {
  return (reports ?? []).filter(
    (report) => report.compatibilityType === compatibilityType,
  );
}

export function compatibilityCategoryFromSearch(
  search: string,
): CompatibilityCategory {
  const type = new URLSearchParams(search).get("type");
  return type === "personal" || type === "business" || type === "team"
    ? type
    : "personal";
}

export function compatibilityPageModeFromSearch(
  search: string,
): CompatibilityPageMode {
  const type = new URLSearchParams(search).get("type");
  return type === "personal" ||
    type === "business" ||
    type === "team" ||
    type === "classroom"
    ? type
    : "personal";
}

export function compatibilityRedirectFromSearch(search: string): string | null {
  return new URLSearchParams(search).get("type") === "marriage"
    ? "/marriage"
    : null;
}

export function isCurrentCompatibilityRequest({
  requestVersion,
  activeVersion,
  requestCategory,
  activeCategory,
}: {
  requestVersion: number;
  activeVersion: number;
  requestCategory: CompatibilityCategory;
  activeCategory: CompatibilityCategory;
}): boolean {
  return (
    requestVersion === activeVersion && requestCategory === activeCategory
  );
}